import React from 'react';
import Select from 'react-select';

interface Option {
  value: string;
  label: string;
}

interface CustomSelectComponentProps {
  label?: string;
  options?: Option[] | null;
  value: Option | null;
  onChange: (selectedOption: Option | null) => void;
  placeholder?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  width?: string;
  fontFamily?: string;
  styles?: any;
}

const CustomSelectComponent: React.FC<CustomSelectComponentProps> = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  isDisabled = false,
  isLoading = false,
  width = '200px',
  fontFamily = 'Lexend Deca',
  styles,
}) => {
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      width: width,
      fontFamily: fontFamily,
    }),
    option: (provided: any) => ({
      ...provided,
      fontFamily: fontFamily,
    }),
  };

  return (
    <div>
      {label && <label style={{ fontFamily }}>{label}</label>}
      {isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '38px' }}>
          <div className="spinner" />
        </div>
      ) : (
        <Select
          options={options || undefined}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          isDisabled={isDisabled}
          styles={styles || customStyles}
        />
      )}
    </div>
  );
};

export default CustomSelectComponent;
